'use strict';
import angular from 'angular';
import _ from 'lodash';

import facebookAudienceHtmlUrl from "../facebookAudiences/views/facebookAudiences.html";

var app = angular.module('app.facebookAudiences.component', []);

app.component('facebookAudiences', {
    bindings: {
        clusterId: '=',
        showActions: '=',
        selectedFacebookAudiences: '=',
    },
    templateUrl: facebookAudienceHtmlUrl,
    controller: function(ProductService) {
        var self = this;

        self.customAudienceList = [];
        self.savedAudienceList = [];

        // Load Facebook audiences
        self.getFacebookAudiences = function() {
            if (typeof self.selectedFacebookAudiences === 'string' && self.selectedFacebookAudiences.length > 0) {
                try {
                    self.selectedFacebookAudiences = JSON.parse(self.selectedFacebookAudiences);
                    console.log('Selected Facebook Audiences converted to JSON:', self.selectedFacebookAudiences);
                } catch (error) {
                    console.error('Error parsing selectedFacebookAudiences JSON:', error);
                }
            }
            ProductService.getFacebookAudiences({ clusterId: self.clusterId }).then(function(success) {
                if (success) {
                    self.customAudienceList = success.custom_audiences || [];
                    self.savedAudienceList = success.saved_audiences || [];
                    processAudiencesData();
                }
            }, function(error) {
                console.error('Error fetching Facebook audiences:', error);
            });
        };

        // Handle selecting or removing audiences
        self.handleSelectAudiences = function(audience, selectedFacebookAudiences, action) {
            // Ensure initialization
            if (!self.selectedFacebookAudiences || !self.selectedFacebookAudiences.length) {
                self.selectedFacebookAudiences[0].customAudiences = []; // Reset custom audiences
                self.selectedFacebookAudiences[0].savedAudiences = [];
            }
            if (action === 'include') {
                // Check if the audience is already included
                var alreadyIncluded = _.find(selectedFacebookAudiences, { id: audience.id });

                if (alreadyIncluded) {
                    // If already included but excluded is true, update it
                    if (alreadyIncluded.excluded === true) {
                        alreadyIncluded.included = true;
                        alreadyIncluded.excluded = false;
                    }
                    // If already included and not excluded, do nothing
                } else {
                    // If not already included, push the audience to the selected list
                    audience.included = true;
                    audience.excluded = false;
                    selectedFacebookAudiences.push(audience);
                }
            }

            // If the action is to exclude an audience
            else if (action === 'exclude') {
                // Check if the audience is already included
                var alreadyExcluded = _.find(selectedFacebookAudiences, { id: audience.id });

                if (alreadyExcluded) {
                    // If already excluded but excluded is true, update it
                    if (alreadyExcluded.included === true) {
                        alreadyExcluded.excluded = true;
                        alreadyExcluded.included = false;
                    }
                    // If already excluded and not included, do nothing
                } else {
                    // If not already excluded, push the audience to the selected list
                    audience.excluded = true;
                    audience.included = false;
                    selectedFacebookAudiences.push(audience);
                }
            }
            // If the action is to remove an audience
            else {
                // Remove the audience from the selected list
                audience.included = false;
                audience.excluded = false;
                _.remove(selectedFacebookAudiences, { id: audience.id });
                function resetAudienceFlags(audienceList) {
                    var audienceInList = _.find(audienceList, { id: audience.id });
                    if (audienceInList) {
                        audienceInList.included = false;
                        audienceInList.excluded = false;
                    }
                }

                resetAudienceFlags(self.customAudienceList);
                resetAudienceFlags(self.savedAudienceList);
            }

        };

        // Process Audiences for selected state
        function processAudiencesData() {
            if (!self.selectedFacebookAudiences || self.selectedFacebookAudiences.length === 0) {
                // Initialize it with empty customAudiences and savedAudiences
                self.selectedFacebookAudiences = [{
                    customAudiences: [],
                    savedAudiences: []
                }];
            } else {
                // Reset custom audiences and saved audiences if no audiences are selected
                if (self.selectedFacebookAudiences[0].customAudiences.length === 0) {
                    self.selectedFacebookAudiences[0].customAudiences = [];
                    self.selectedFacebookAudiences[0].savedAudiences = [];
                }
            }
            self.selectedFacebookAudiences[0].customAudiences.forEach(function(selectedItem) {
                var audience = _.find(self.customAudienceList, { name: selectedItem.name });
                if (audience) {
                    audience.included = selectedItem.included;
                    audience.excluded = selectedItem.excluded;
                }
            });

            self.selectedFacebookAudiences[0].savedAudiences.forEach(function(selectedItem) {
                var audience = _.find(self.savedAudienceList, { name: selectedItem.name });
                if (audience) {
                    audience.included = selectedItem.included;
                    audience.excluded = selectedItem.excluded;
                }
            });
        }

        self.getFacebookAudiences();
    }
});
